import { render, staticRenderFns } from "./GradingDialog.vue?vue&type=template&id=a07c4b00&scoped=true"
import script from "./GradingDialog.vue?vue&type=script&lang=js"
export * from "./GradingDialog.vue?vue&type=script&lang=js"
import style0 from "./GradingDialog.vue?vue&type=style&index=0&id=a07c4b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07c4b00",
  null
  
)

export default component.exports